import { TimezoneInfo } from '../types/timezone';
import { TimezoneService } from '../services/timezone/timezoneService';

export function getTimezoneForLocation(location: string): TimezoneInfo {
  return TimezoneService.getTimezoneForLocation(location);
}

export { TimezoneFormatter } from '../services/timezone/timezoneFormatter';